import styles from "./FiltersMenu.module.scss";
import classNames from "classnames";
import { useFiltersMenu } from "../../../../../../../hooks/useFiltersMenu";
import { SingleOption } from "../../../../../../components/FilterMenu";
import { useDispatch } from "react-redux";
import { setSelectedQueryModal } from "../../../../../../../redux/SingleDataset/actions";
import { useQueryModal } from "../../../../../../../hooks/UseQueryModal/useQueryModal";
import { useCallback } from "react";
import { FilterMenuItemType } from "../../../../../../../types";
import { CustomMetadataField } from "vl-api/vlSchemas";

type FiltersMenuProps = {
  className: string;
  onItemClick: () => void;
  datasetId: string;
  searchQuery?: string;
  customMetadataData?: CustomMetadataField[] | null;
};

export const FiltersMenu = ({
  className,
  onItemClick,
  datasetId,
  searchQuery,
  customMetadataData,
}: FiltersMenuProps) => {
  const dispatch = useDispatch();
  const onSelect = useCallback(
    (type: FilterMenuItemType) => {
      dispatch(setSelectedQueryModal({ type, fromSearch: true }));
      onItemClick();
    },
    [dispatch, onItemClick],
  );

  const { filterOptions } = useFiltersMenu({
    onSelect,
    datasetId,
    searchQuery,
    customMetadataData,
  });

  const showNoResult = filterOptions.length === 0 && searchQuery;

  return (
    <div className={classNames(styles.FiltersMenu, className)}>
      <div className={styles.container}>
        <div className={styles.options}>
          {showNoResult ? (
            <div className={styles.noResults}>No matches found</div>
          ) : (
            filterOptions.map((option, index) => (
              <div key={String(`${option.type}${index}`)}>
                <SingleOption
                  name={option.name}
                  icon={option.icon}
                  disabled={option.disabled}
                  tooltipContent={option.tooltipContent}
                  onSelect={option.handleSelect}
                  className={styles.option}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export const FilterItem = ({ className }: { className: string }) => {
  const modal = useQueryModal();
  return (
    <div className={classNames(styles.FiltersMenu, className)}>
      <div className={classNames(styles.container, styles.item)}>{modal}</div>
    </div>
  );
};
